/**
 * When dispatching `fetchLocationsSucceeded`, list rows often omit `contacts` or send `contacts: null`.
 * Merging avoids wiping contacts from a detail/full response. When the store already has an array
 * (including `[]` after deleting all contacts), we copy it onto the list row until a payload that
 * actually includes `contacts` replaces it.
 */
export function mergeLocationListRowsWithStoredContacts(
  incomingItems: Locality[],
  storedEntities: Partial<Record<number, Locality>>,
): Locality[] {
  return incomingItems.map(incoming => {
    const existing = storedEntities[incoming.id];
    const hasContactsKey = Object.prototype.hasOwnProperty.call(incoming, "contacts");
    const incomingContacts = hasContactsKey ? incoming.contacts : undefined;
    const incomingLacksContactsPayload = !hasContactsKey || incomingContacts === null || incomingContacts === undefined;

    if (existing && incomingLacksContactsPayload && Array.isArray(existing.contacts)) {
      return { ...incoming, contacts: existing.contacts };
    }
    return incoming;
  });
}
